/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const headerUserConfig = {
  headerTitle: 'Admin Users List',
  headerDescription: 'List of admin users who manages this admin portal.',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
  headerAction1: {
    id: 'add_user',
    label: 'New Admin',
    icon: 'PlusIcon',
  },
  headerAction2: [
    {
      id: 'import_users',
      label: 'Import Admins',
    },
  ],
};
